/**
 * Fetches a single ticket by id from the server; debounces rapid requests for
 * the same ticket
 *
 * NOTE: This is a redux action, so it must be dispatched
 */

import { ticketFetching } from './actions';
import loadRecords from 'actions/load-records';
import readTicketRoute from 'api/routes/tickets/read-ticket';

const promises = {};

export default function fetchTicket(id) {
  return (dispatch) => {
    if (!Number.isInteger(id) || id <= 0) {
      return;
    } else if (id in promises) {
      return promises[id];
    }
    dispatch(ticketFetching(id));
    const promise = readTicketRoute(id)
      .then(({ data }) => {
        dispatch(loadRecords(data));
      })
      .finally(() => {
        delete promises[id];
      });
    promises[id] = promise;
    return promise;
  };
}
